import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames/bind';
import displayName from 'component-lib/displayName';

import styles from './styles.scss';

const cx = classNames.bind(styles);

export default function ContainerGroup(props) {
    const { border, inset, children } = props;
    const className = cx({
        'container-group': true,
        'container-group-border': border,
        'container-group-inset': inset,
    });

    return (
        <div className={className}>
            {children}
        </div>
    );
}

ContainerGroup.displayName = displayName('Forms/InputGroup/ContainerGroup');

ContainerGroup.propTypes = {
    border: PropTypes.bool,
    inset: PropTypes.bool,
    children: PropTypes.node.isRequired,
};

ContainerGroup.defaultProps = {
    border: false,
    inset: false,
};
